import {Component, Injector, Input, OnInit} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {parseNumber} from "@progress/kendo-angular-intl";
import {registerSearchControl} from "../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-year-multi-select-search-control",
    templateUrl: "../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        registerSearchControl(YearMultiSelectSearchControlComponent)
    ]
})
export class YearMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> implements OnInit {
    private _startDate: string;
    private _endDate: string;

    private readonly number_years = 20;

    constructor(injector: Injector) {
        super(undefined, injector);
    }

    convertDate(date: string): Date {
        if (date) {
            const parts: string[] = date.split("-");
            return new Date(parseNumber(parts[0]), parseNumber(parts[1]) - 1, parseNumber(parts[2]));
        } else {
            return undefined;
        }
    }

    ngOnInit(): void {
        this.getValidYears();
    }

    get startDate(): string {
        return this._startDate;
    }

    @Input()
    set startDate(value: string) {
        if (value !== this._startDate) {
            this._startDate = value;
            this.getValidYears();
        }
    }

    get endDate(): string {
        return this._endDate;
    }

    @Input()
    set endDate(value: string) {
        if (value !== this._endDate) {
            this._endDate = value;
            this.getValidYears();
        }
    }

    private getValidYears(): void {
        const endYear: number = this.endDate != undefined ? this.convertDate(this.endDate).getFullYear() : new Date().getFullYear();
        const startYear: number = this.startDate != undefined ? this.convertDate(this.startDate).getFullYear() : endYear - this.number_years;

        const data: any[] = [];
        for (let year: number = endYear; year >= startYear; year--) {
            data.push({label: "'" + year + "'", value: year.toString()})
        }
        this.buildData(data);
    }
}
